import React, { Component } from 'react'
import Creater from '../../controller/Creater'

export default class FlashCardAdd extends Component {

    state = {
        catg: '',
        word: '',
        pronaun: '',
        meaning: ''
    }

    changeFx = (e) => {
        this.setState(
            { [e.target.name] : e.target.value }
        )
    }

    addFx = (e) => {

        e.preventDefault()

        let condition = {
            url : '/api/fcard/add',
            data : {
                catg: this.state.catg,
                word: this.state.word,
                pronaun: this.state.pronaun,
                meaning: this.state.meaning,
                isMem: false
            }
        }

        Creater(condition, res => {
            
            console.log(res.message)

            this.props.closeMe()

        })
    }

    closeFx = () => {

        this.props.closeMe()
    }


    render() {

        return (

            <div className='NightWrapper'>

                <div className='FcardAddContainer'>

                    <select name='catg' value={this.state.catg} onChange={this.changeFx}>
                        <option value='cn'>Chinese</option>
                        <option value='en'>English</option>
                        <option value='jp'>Japanese</option>
                        <option value='es'>Español</option>
                    </select>

                    <br />

                    <input name='word' type='text' value={this.state.word} onChange={this.changeFx} />

                    <br />

                    <input name='pronaun' type='text' value={this.state.pronaun} onChange={this.changeFx} />

                    <br />

                    <textarea name='meaning' value={this.state.meaning} onChange={this.changeFx}></textarea>

                    <br /><br /><br />

                    <div>

                        <span className='RegBtn' onClick={this.addFx}>SAVE</span>

                        <span className='RegBtn' onClick={this.closeFx}>CANCEL</span>

                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/flashcard/FlashcardAdd.js